function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { moduleWrapper } from '../components/moduleWrapper';
import { FrameWrapper } from './FrameWrapper';
class StaticChaynsApi {
  constructor() {
    _defineProperty(this, "getSite", () => this._wrapper.values.site);
    const wrapper = new FrameWrapper();
    moduleWrapper.current = wrapper;
    this._wrapper = wrapper;
    this.ready = wrapper.init();
    this.addDataListener = wrapper.addDataListener;
    Object.entries(wrapper.functions).forEach(_ref => {
      let [k, v] = _ref;
      this[k] = v;
    });
  }
}
export default StaticChaynsApi;